module.exports = __webpack_public_path__ + "img/banner1.3aa8cc72.webp";